import Vue from 'vue';
import App from './App.vue';
// import Vuetify from 'vuetify';
import router from '@/router';
import store from '@/store';
import Vuex from 'vuex';
import '@/plugins/axios';
import '@/plugins/templates';
import vuetify from '@/plugins/vuetify';
import VCalendar from 'v-calendar';

Vue.use(VCalendar, {
    firstDayOfWeek: 2,
    locale: "ru",
    componentPrefix: "vc",
});

import _ from 'lodash';
Vue.use(_);

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
Vue.component('VueSlider', VueSlider);

export const eventBus = new Vue();

Vue.config.productionTip = false;

Vue.use(Vuex);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app')
